import React, { Component, Fragment } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Grid,
  CircularProgress,
  Typography,
  ListItemIcon,
} from '@material-ui/core';
import { Link } from '@material-ui/icons/';
import { FilterTabs } from './containers/FilterTabs';
import Pane from './containers/Pane';
import { Filters } from './../services/Filters';

const _filters = new Filters();

class Maps extends Component {

  constructor() {
    super()
    this.state = {
      selectedFilter: 0,
      isLoading: false
    }
  }

  componentDidMount() {
    this.props.onRefreshData();
  }

  onExternalLink = (e, url) => {
    e.preventDefault();
    window.open(url);
  }

  getItemsByFilter() {
    return Object.entries(
      this.props.links.reduce((links, link) => {
        const {filters} = link;

        links[filters] = links[filters]
        ? [...links[filters], link]
        : [link]

        return links;
      }, {})
    );
  }

  handleFilterSelected = selectedFilter => {
    this.setState({
      selectedFilter
    });
  };

  render() {
    const {
      filters,
      links,
      translations,
      appLanguage,
    } = this.props;
    const { selectedFilter, } = this.state;
    return (
      <Fragment>
        {
          filters.length > 0
          ? (
            <Grid container justify="center">
              <Grid item xs sm={9} lg={8} xl={7}>
                <FilterTabs
                  filters={filters}
                  selectedFilter={selectedFilter}
                  onFilterSelect={this.handleFilterSelected}
                />
              </Grid>
            </Grid>
          ) : (
            null
          )
        }
        <Grid container justify="center">
          <Grid item xs sm={9} lg={8} xl={7}>
            <Pane header={translations.t_TITLE_MAPS[appLanguage]}>
              {links.length < 0
                ? <CircularProgress />
                : (
                    <Fragment>
                      {this.getItemsByFilter().map(([filter, links]) =>
                        !selectedFilter || selectedFilter === filter
                        ? (
                            filter === '' ? filter = 'General' : filter,
                            <Fragment key={filter}>
                              <Typography
                                variant='h5'
                              >
                                {filter !== 'undefined' ? filter : null}
                              </Typography>
                              <List>
                                {links.map(({name, id, url}) =>
                                  <ListItem
                                    key={id}
                                    divider
                                    button
                                    onClick={(e) => this.onExternalLink(e, url)}
                                  >
                                    <ListItemIcon><Link /></ListItemIcon>
                                    <ListItemText>
                                      {name}
                                    </ListItemText> 
                                    {url ? _filters.urlIcon(url) : null}
                                  </ListItem>
                                )}
                              </List>
                            </Fragment>
                          ) : null
                      )}
                    </Fragment>
                  )
                } 
            </Pane>
          </Grid>
        </Grid>
      </Fragment>
    );
  }

}

export default Maps;


// WEBPACK FOOTER //
// ./src/components/Maps.js